
//Funcion para generar un nuevo chat a partir de un mensaje entrante.
//Recibe como parámetros la lista de los chats que están dentro del inbox, y el dato del nuevo chat entrante.
export const newMessageInInbox = (chats, newChat, searching) => {

    //Sacar el idChat al que pertenece el nuevo mensaje.
    let idChat = newChat.IdChat;

    //console.log('el  nuevo chat', newChat);
    //console.log('el mensaje del nuevo chat', newChat.Message);

    //Buscar entre la lista de chats del inbox, un chat que tenga ese id.
    let updatedChats = chats.map(chat => {
        if (chat.IdChat === idChat) {
            return { ...chat, 
                Message: newChat.Message, 
                FechaHora: newChat.FechaHora, 
                Type: newChat.Type, 
                UrlFile: newChat.UrlFile, 
                Iniciales: newChat.Iniciales, 
                IdUsuarioAsignado: newChat.IdUsuarioAsignado,
                Finalizado: newChat.Finalizado,
            };
        } else {
            return chat;
        }
    });

    let existingChat = chats.find(chat => chat.IdChat === idChat); // Si no se encuentra el chat, agregarlo como un nuevo chat.
    if (!existingChat && !searching) { // Si no se encuentra ningun chat en la lista de chats, pero a la vez no se esta buscando ningun chat desde el buscador, solo asi agregar el chat a la lista.
        updatedChats.push(newChat);
    };

    return updatedChats; //Retorna el la lista de chats actualizada.

};